import { useCallback, useEffect, useMemo, useState } from 'react'

interface IUseTimerCore {
  (date: string): {
    days: string
    hours: string
    minutes: string
    seconds: string
  }
}

export const useTimerCore: IUseTimerCore = (date) => {
  const result = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return Date.parse(date) - Date.parse(new Date())
  }, [date])

  const getSeconds = useCallback((t) => {
    return Math.floor((t / 1000) % 60)
  }, [])

  const getMinutes = useCallback((t) => {
    return Math.floor((t / 1000 / 60) % 60)
  }, [])

  const getHours = useCallback((t) => {
    return Math.floor((t / 1000 / 60 / 60) % 24)
  }, [])

  const getDays = useCallback((t) => {
    return Math.floor(t / 1000 / 60 / 60 / 24)
  }, [])

  const [secondsVal, setSeconds] = useState(
    getSeconds(result) > 0 ? getSeconds(result) : 0
  )
  const [minutesVal, setMinutes] = useState(
    getMinutes(result) > 0 ? getMinutes(result) : 0
  )
  const [hoursVal, setHours] = useState(getHours(result) > 0 ? getHours(result) : 0)
  const [daysVal, setDays] = useState(getDays(result) > 0 ? getDays(result) : 0)

  useEffect(() => {
    const interval = setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const res = Date.parse(date) - Date.parse(new Date())

      if (res > 0) {
        setSeconds(getSeconds(res))
        setMinutes(getMinutes(res))
        setHours(getHours(res))
        setDays(getDays(res))
      } else {
        setSeconds(0)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const days = useMemo(() => {
    if (daysVal > 9) {
      return `${daysVal}`
    }

    return `0${daysVal}`
  }, [daysVal])

  const hours = useMemo(() => {
    if (hoursVal > 9) {
      return `${hoursVal}`
    }

    return `0${hoursVal}`
  }, [hoursVal])

  const minutes = useMemo(() => {
    if (minutesVal > 9) {
      return `${minutesVal}`
    }

    return `0${minutesVal}`
  }, [minutesVal])

  const seconds = useMemo(() => {
    if (secondsVal > 9) {
      return `${secondsVal}`
    }

    return `0${secondsVal}`
  }, [secondsVal])

  return {
    days,
    hours,
    minutes,
    seconds,
  }
}
